import { z } from 'zod';
import { inboundEnrollConfigSchema } from './inboundEnroll.js';
import { complianceSettingsSchema } from './complianceSettings.js';
const slugRegex = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
export const projectCreateSchema = z.object({
    slug: z.string().regex(slugRegex).min(2).max(64),
    name: z.string().min(1).max(200),
    domain: z.string().max(253).optional().nullable(),
    color: z
        .string()
        .regex(/^#[0-9A-Fa-f]{6}$/)
        .optional()
        .nullable(),
    from_name: z.string().max(200).optional().nullable(),
    signature_html: z.string().max(20000).optional().nullable(),
    branding: z.record(z.string(), z.unknown()).optional(),
    allowed_origins: z.array(z.string().url()).optional(),
});
export const projectLifecycleSchema = z.enum(['active', 'archived']);
export const projectUpdateSchema = projectCreateSchema
    .partial()
    .omit({ slug: true })
    .extend({
    lifecycle_status: projectLifecycleSchema.optional(),
    timezone: z.string().max(64).optional(),
    locale: z.string().max(16).optional(),
    compliance_address: z.string().max(2000).optional().nullable(),
    mail_require_legal_basis: z.boolean().optional(),
    inbound_enroll: inboundEnrollConfigSchema.optional().nullable(),
    compliance_settings: complianceSettingsSchema.optional(),
});
export const projectMemberUpdateSchema = z.object({
    role: z.enum([
        'viewer',
        'editor',
        'sender',
        'admin',
        'read_only',
        'marketing',
        'sales',
        'owner',
    ]),
});
//# sourceMappingURL=project.js.map